import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import ModernProviderList from './components/ModernProviderList';
import Login from './components/Login';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';
import Dashboard from './components/ModernDashboard';
import ProviderDetail from './components/ModernProviderDetail';
import MediaManager from './components/MediaManager';
import EnhancedAdminPanel from './components/EnhancedAdminPanel';
import ImpersonationBanner from './components/ImpersonationBanner';
import BulkContactForm from './components/BulkContactForm';
import ClaimListing from './components/ClaimListing';
import ApplyForListing from './components/ApplyForListing';
import Shortlist from './components/Shortlist';

// Wedding page components
import CoupleRegister from './components/wedding/CoupleRegister';
import CoupleLogin from './components/wedding/CoupleLogin';
import CoupleForgotPassword from './components/wedding/CoupleForgotPassword';
import CoupleDashboard from './components/wedding/CoupleDashboard';
import PageBuilder from './components/wedding/PageBuilder';
import GuestManager from './components/wedding/GuestManager';
import RSVPDashboard from './components/wedding/RSVPDashboard';
import RSVPForm from './components/wedding/RSVPForm';
import WeddingPage from './components/wedding/WeddingPage';
import PagePreview from './components/wedding/PagePreview';

function App() {
  const isAuthenticated = () => {
    return localStorage.getItem('token') !== null;
  };

  const isCoupleAuthenticated = () => {
    return localStorage.getItem('coupleToken') !== null;
  };

  const ProtectedRoute = ({ children }) => {
    return isAuthenticated() ? children : <Navigate to="/login" />;
  };

  const CoupleProtectedRoute = ({ children }) => {
    return isCoupleAuthenticated() ? children : <Navigate to="/couple/login" />;
  };

  return (
    <Router>
      <ImpersonationBanner />
      <Routes>
        {/* Existing provider routes */}
        <Route path="/" element={<ModernProviderList />} />
        <Route path="/providers" element={<ModernProviderList />} />
        <Route path="/provider/:id" element={<ProviderDetail />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/claim/:id" element={<ClaimListing />} />
        <Route path="/apply" element={<ApplyForListing />} />
        <Route path="/shortlist" element={<Shortlist />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/media"
          element={
            <ProtectedRoute>
              <MediaManager />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <EnhancedAdminPanel />
            </ProtectedRoute>
          }
        />
        <Route path="/bulk-contact" element={<BulkContactForm />} />

        {/* Couple auth routes */}
        <Route path="/couple/register" element={<CoupleRegister />} />
        <Route path="/couple/login" element={<CoupleLogin />} />
        <Route path="/couple/forgot-password" element={<CoupleForgotPassword />} />

        {/* Couple dashboard routes (protected) */}
        <Route
          path="/couple/dashboard"
          element={
            <CoupleProtectedRoute>
              <CoupleDashboard />
            </CoupleProtectedRoute>
          }
        />
        <Route
          path="/couple/builder"
          element={
            <CoupleProtectedRoute>
              <PageBuilder />
            </CoupleProtectedRoute>
          }
        />
        <Route
          path="/couple/guests"
          element={
            <CoupleProtectedRoute>
              <GuestManager />
            </CoupleProtectedRoute>
          }
        />
        <Route
          path="/couple/rsvps"
          element={
            <CoupleProtectedRoute>
              <RSVPDashboard />
            </CoupleProtectedRoute>
          }
        />

        <Route
          path="/couple/preview"
          element={
            <CoupleProtectedRoute>
              <PagePreview />
            </CoupleProtectedRoute>
          }
        />

        {/* Public RSVP form */}
        <Route path="/rsvp/:token" element={<RSVPForm />} />

        {/* Public wedding page - MUST be last (catch-all for slugs) */}
        <Route path="/:slug" element={<WeddingPage />} />
      </Routes>
    </Router>
  );
}

export default App;
